module.exports = __webpack_public_path__ + "static/media/фотозона.ca4d46e8.jpg";